import React from 'react';
import { LogoA, LogoB, LogoC } from '@/components/KutroLogo';

export default function LogoReview() {
  return (
    <div className="min-h-screen bg-[#050505] p-12">
      <h1 className="text-4xl font-bold text-white mb-12 text-center">KOJIRU Logo Options</h1>
      
      <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
        {/* Logo A */}
        <div className="bg-[#0A0A0A] rounded-2xl p-8 border border-white/10">
          <div className="text-center mb-6">
            <span className="text-2xl font-bold text-blue-500">Option A</span>
            <p className="text-gray-400 text-sm mt-2">Geometric 3D Cube</p>
          </div>
          
          <div className="flex flex-col items-center gap-8">
            {/* Large */}
            <div className="bg-[#111] p-6 rounded-xl">
              <LogoA size={120} />
            </div>
            
            {/* With text */}
            <div className="flex items-center gap-3 bg-[#111] p-4 rounded-xl">
              <LogoA size={48} />
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                KOJIRU
              </span>
            </div>
            
            {/* Small */}
            <div className="flex gap-4">
              <div className="bg-[#111] p-3 rounded-lg"><LogoA size={32} /></div>
              <div className="bg-white p-3 rounded-lg"><LogoA size={32} /></div>
            </div>
          </div>
          
          <div className="mt-6 text-center text-gray-500 text-sm">
            <p>Modern • Professional • Tech-forward</p>
          </div>
        </div>

        {/* Logo B */}
        <div className="bg-[#0A0A0A] rounded-2xl p-8 border border-white/10">
          <div className="text-center mb-6">
            <span className="text-2xl font-bold text-green-500">Option B</span>
            <p className="text-gray-400 text-sm mt-2">Chain Link Circle</p>
          </div>
          
          <div className="flex flex-col items-center gap-8">
            {/* Large */}
            <div className="bg-[#111] p-6 rounded-xl">
              <LogoB size={120} />
            </div>
            
            {/* With text */}
            <div className="flex items-center gap-3 bg-[#111] p-4 rounded-xl">
              <LogoB size={48} />
              <span className="text-2xl font-bold bg-gradient-to-r from-green-500 via-blue-500 to-purple-500 bg-clip-text text-transparent">
                KOJIRU
              </span>
            </div>
            
            {/* Small */}
            <div className="flex gap-4">
              <div className="bg-[#111] p-3 rounded-lg"><LogoB size={32} /></div>
              <div className="bg-white p-3 rounded-lg"><LogoB size={32} /></div>
            </div>
          </div>
          
          <div className="mt-6 text-center text-gray-500 text-sm">
            <p>Connected • Community • Blockchain</p>
          </div>
        </div>

        {/* Logo C */}
        <div className="bg-[#0A0A0A] rounded-2xl p-8 border border-white/10">
          <div className="text-center mb-6">
            <span className="text-2xl font-bold text-orange-500">Option C</span>
            <p className="text-gray-400 text-sm mt-2">Abstract K with Accents</p>
          </div>
          
          <div className="flex flex-col items-center gap-8">
            {/* Large */}
            <div className="bg-[#111] p-6 rounded-xl">
              <LogoC size={120} />
            </div>
            
            {/* With text */}
            <div className="flex items-center gap-3 bg-[#111] p-4 rounded-xl">
              <LogoC size={48} />
              <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 via-blue-500 to-purple-500 bg-clip-text text-transparent">
                KOJIRU
              </span>
            </div>
            
            {/* Small */}
            <div className="flex gap-4">
              <div className="bg-[#111] p-3 rounded-lg"><LogoC size={32} /></div>
              <div className="bg-white p-3 rounded-lg"><LogoC size={32} /></div>
            </div>
          </div>
          
          <div className="mt-6 text-center text-gray-500 text-sm">
            <p>Dynamic • Bold • Innovative</p>
          </div>
        </div>
      </div>

      {/* Slogans Section */}
      <div className="mt-16 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-white mb-8 text-center">Marketing Slogans</h2>
        
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl p-6 border border-blue-500/30">
            <span className="text-blue-400 text-sm font-medium">Slogan A</span>
            <p className="text-2xl font-bold text-white mt-2">"Lending, Evolved."</p>
            <p className="text-gray-400 text-sm mt-3">Short, powerful, forward-thinking</p>
          </div>
          
          <div className="bg-gradient-to-br from-green-500/20 to-blue-500/20 rounded-xl p-6 border border-green-500/30">
            <span className="text-green-400 text-sm font-medium">Slogan B</span>
            <p className="text-2xl font-bold text-white mt-2">"AI Meets DeFi. You Win."</p>
            <p className="text-gray-400 text-sm mt-3">Benefit-focused, tech-forward</p>
          </div>
          
          <div className="bg-gradient-to-br from-orange-500/20 to-red-500/20 rounded-xl p-6 border border-orange-500/30">
            <span className="text-orange-400 text-sm font-medium">Slogan C</span>
            <p className="text-2xl font-bold text-white mt-2">"Flat Fee Home"</p>
            <p className="text-gray-400 text-sm mt-3">Action-oriented, dual-audience</p>
          </div>
        </div>
      </div>
    </div>
  );
}
